import Promise from 'bluebird'
import dependencyGraph from '../lib/dependency_graphs/dependency-graph.js'

export default function (tasks) {
  return new Promise((resolve) => {
    const graph = dependencyGraph(tasks);
    resolve(graph);
  });
};
